import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from 'generated/graphql';

import TalentReviewCell from './TalentReviewCell';
import TalentReviewLabel from './TalentReviewLabel';

const Row = styled(Flex)<{ dragging?: boolean }>`
	&:not(:last-child) {
		margin-bottom: ${(props) => (props.dragging ? 14 : 24)}px;
	}
`;

const YLabel = styled(Flex)`
	position: relative;
	flex-grow: 0;
	flex-shrink: 0;
	width: 30px;
	align-items: center;
`;

const YLabelText = styled(Box)<{ main?: boolean }>`
	${(props) =>
		props.main
			? `
		color: ${props.theme.colors.slateBlue};
		font-weight: bold;
	`
			: `
		color: ${props.theme.colors.lightBlueDark};
	`}
`;

const XLabel = styled(Flex)<{ main?: boolean; columns: number; translateX?: number }>`
	flex-grow: 0;
	flex-shrink: 0;
	margin-left: 10px;
	justify-content: center;

	${(props) => props.translateX && `transform: translateX(${props.translateX}px)`};

	${(props) =>
		props.main
			? `
		color: ${props.theme.colors.slateBlue};
		font-weight: bold;
		width: ${props.columns * 170 - 10}px;
	`
			: `
		color: ${props.theme.colors.lightBlueDark};
		width: 160px;
	`}
`;

export default function TalentReviewGrid(props: {
	template: graphql.TalentReviewTemplate;
	users: graphql.User[];
	dragging?: boolean;
	temporaryPlacements: graphql.TalentReviewPlacement[];
	onUpdateMotivation: (userID: string, motivation: string) => void;
	readonly?: boolean;
}) {
	return (
		<Box>
			<Flex>
				<YLabel mr={2}>
					<YLabelText main>
						<TalentReviewLabel text={props.template.yAxis.label} vertical />
					</YLabelText>
				</YLabel>
				<Box flexGrow={0} flexShrink={0}>
					{props.template.yAxis.ticks
						.map((_, row) => (
							<Row key={row}>
								<YLabel>
									<YLabelText>
										<TalentReviewLabel text={props.template.yAxis.ticks[row]} vertical />
									</YLabelText>
								</YLabel>
								{props.template.xAxis.ticks.map((_, column) => (
									<TalentReviewCell
										key={column}
										row={row}
										column={column}
										cell={props.template.cells[row][column]}
										users={props.users}
										dragging={props.dragging}
										temporaryPlacements={props.temporaryPlacements}
										onUpdateMotivation={props.onUpdateMotivation}
										readonly={props.readonly}
									/>
								))}
							</Row>
						))
						.reverse()}
				</Box>
			</Flex>
			<Box>
				<Row mt={24} mb={0}>
					<YLabel mr={2} />
					<YLabel />
					{props.template.xAxis.ticks.map((_, column) => (
						<XLabel key={column} columns={1}>
							<TalentReviewLabel text={props.template.xAxis.ticks[column]} />
						</XLabel>
					))}
				</Row>
			</Box>
			<Row mt={2}>
				<YLabel mr={2} />
				<YLabel />
				<XLabel main columns={props.template.xAxis.ticks.length}>
					<TalentReviewLabel text={props.template.xAxis.label} />
				</XLabel>
			</Row>
		</Box>
	);
}
